// Shared by every stored-timestamp reader: a future value is never legitimate, since only this
// mechanism's own writers persist these timestamps, always as a fresh Date.now().
export const isValidEpochMs = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value <= Date.now()
